<template>
  <FooterAeskulab v-if="$route.name && $route.name.startsWith('aeskuLab')" />
  <FooterGeneral v-else />
</template>

<script>
import FooterAeskulab from '@/components/Molecules/FooterAeskulab';
import FooterGeneral from '@/components/Molecules/FooterGeneral';

export default {
  name: 'Footer',
  components: { FooterGeneral, FooterAeskulab }
};
</script>
